import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../common/widgets/PopoverDialog';
import { ProductTypes } from '../../../enums';
import { BundleProductModel } from '../../../models/Product';
import { resources } from '../../../resources/resources';

interface Props {
  bundleProducts: BundleProductModel[];
  productTypeId: ProductTypes;
}

export default function ProductBundleInfo(props: Readonly<Props>) {
  const { t: translate } = useTranslation();
  const { bundleProducts, productTypeId } = props;

  const isGiftCard = productTypeId === ProductTypes.DefaultProduct;
  const isCashback = productTypeId === ProductTypes.CashBack;
  const isDiscountCode = productTypeId === ProductTypes.FreeLinkVoucher;

  const hasCashback = bundleProducts.some(
    product => product.productTypeId === ProductTypes.CashBack,
  );

  const hasDiscountCode = bundleProducts.some(
    product => product.productTypeId === ProductTypes.FreeLinkVoucher,
  );

  const hasGiftCard = bundleProducts.some(
    product => product.productTypeId === ProductTypes.DefaultProduct,
  );

  const getHowToFinishOrderMessage = () => {
    if (hasDiscountCode || isDiscountCode) {
      return resources.bundleProducts.info.variants.promoCodeAndGiftCard;
    } else {
      return resources.bundleProducts.info.variants.giftCardOnly;
    }
  };

  const showGiftCardStep = isGiftCard || hasGiftCard;
  const showDiscountCodeStep = isDiscountCode || hasDiscountCode;
  const showCashbackStep = isCashback || hasCashback;

  if (!hasCashback && !hasDiscountCode && !hasGiftCard) {
    return null;
  }

  return (
    <div className="product-bundle-info">
      <div className="product-bundle-info__header">
        <div className="product-bundle-info__icon">
          <Icons.PaymentOptions />
        </div>

        <div className="product-bundle-info__title">
          <span>{translate(resources.bundleProducts.info.benefitTip)}</span>

          <PopoverDialog
            className="checkout-info-dropdown"
            placement="right"
            closeFromContent
            type="hover"
            content={
              <span>{translate(resources.bundleProducts.info.tooltip)}</span>
            }
          >
            <span className="product-bundle-info__info-btn">
              <Icons.InfoSummary />
            </span>
          </PopoverDialog>
        </div>
      </div>

      <ul className="product-bundle-info__list">
        {showGiftCardStep && (
          <li>
            <Icons.CheckDark />
            <span>{translate(resources.bundleProducts.info.buyGiftCard)}</span>
          </li>
        )}

        {showDiscountCodeStep && (
          <li>
            <Icons.CheckDark />
            <span>
              {translate(resources.bundleProducts.info.copyPromoCode)}
            </span>
          </li>
        )}

        {showCashbackStep && (
          <li>
            <Icons.CheckDark />
            <span>
              {translate(resources.bundleProducts.info.shopViaCashbackLink)}
            </span>
          </li>
        )}

        <li>
          <Icons.CheckDark />
          <span>{translate(getHowToFinishOrderMessage())}</span>
        </li>
      </ul>
    </div>
  );
}
